import axios from '../Api/axios';
import useAuth from './useAuth';

 const useApi = () => {
    const {getToken} = useAuth();
    axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`;
    return axios;
}

export default useApi;